// React Imports
import { ReactElement } from "react";

// Third Party Libraries Imports
import { Pagination, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { CaretUpFilled, CaretDownFilled } from "@ant-design/icons";

// Style Imports
import "./custom-table.scss";

interface CustomTableProps {
  columns: ColumnsType<any>;
  data: any;
  showPagination?: boolean;
  style?: React.CSSProperties;
  loading?: boolean;
  pageSize?: number;
  page?: number;
  onPageChange?: (page: number) => void;
  handleTableChange?: (pagination, filters, sorter) => void;
  totalCount?: number;
  expandable?: any;
}

const CustomTable: React.FC<CustomTableProps> = ({
  columns,
  data,
  showPagination = false,
  style,
  loading,
  pageSize,
  page,
  onPageChange,
  handleTableChange,
  totalCount,
  expandable,
}: any): ReactElement => {
  
  return (
    <div className="table-container w-full flex flex-col">
      <Table
        columns={columns.map((column) => {
          return {
            ...column,
            sortIcon: (order: any) => {
              return order?.sortOrder === "ascend" ? (
                <div className="flex h-[30px]">
                  <CaretUpFilled style={{ color: "#002F6C" }} />
                </div>
              ) : order?.sortOrder === "descend" ? (
                <div className="flex flex-col gap-0 h-[30px]">
                  <CaretUpFilled style={{ color: "#002F6C" }} />
                  <CaretDownFilled style={{ color: "#002F6C" }} />
                </div>
              ) : (
                <div className="flex h-[30px]">
                  <CaretDownFilled style={{ color: "#002F6C" }} />
                </div>
              );
            },
          };
        })}
        dataSource={data}
        pagination={false}
        style={style}
        loading={loading}
        rowKey={(record) => record?.id}
        onChange={handleTableChange}
        expandable={expandable}
      />
      {showPagination && data?.length ? (
        <Pagination
          total={totalCount}
          defaultCurrent={1}
          pageSize={pageSize}
          showTotal={(total, range) => {
            const [start, end] = range;
            return `Showing ${start} to ${end} of ${total} entries`;
          }}
          showSizeChanger={false}
          onChange={(page) => {
            onPageChange(page);
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomTable;
